/**
 * HL7 patient JSON parser — mirrors Android DefaultMedicalDataParser.getPatientData().
 * Accepts the full HL7 payload (object or JSON string) and reads nested key values
 * from a named segment/object.
 */

function parseHl7Date(date) {
  if (typeof date !== 'string') {
    return '';
  }

  const len = date.length;
  let formatted = '';

  try {
    if (len >= 8) {
      formatted = date.substring(0, 4) + '-' + date.substring(4, 6) + '-' + date.substring(6, 8);
    }
    if (len >= 10) {
      formatted = formatted + '  ' + date.substring(8, 10);
    }
    if (len >= 12) {
      formatted = formatted + ':' + date.substring(10, 12);
    }
    if (len >= 14) {
      formatted = formatted + ':' + date.substring(12, 14);
    }
  } catch (e) {
    // pass
  }

  return formatted;
}

function findKeyValue(obj, key) {
  if (!obj || typeof obj !== 'object') {
    return null;
  }

  if (Object.prototype.hasOwnProperty.call(obj, key)) {
    return obj[key];
  }

  const keys = Object.keys(obj);
  for (let i = 0; i < keys.length; i++) {
    const childKey = keys[i];
    const value = obj[childKey];

    if (value && typeof value === 'object' && !Array.isArray(value)) {
      const found = findKeyValue(value, key);
      if (found !== null && found !== undefined) {
        return found;
      }
    }

    if (Array.isArray(value)) {
      for (let j = 0; j < value.length; j++) {
        if (value[j] && typeof value[j] === 'object') {
          const found = findKeyValue(value[j], key);
          if (found !== null && found !== undefined) {
            return found;
          }
        }
      }
    }
  }

  return null;
}

function normalizePatientData(patientData) {
  if (!patientData) {
    return null;
  }

  if (typeof patientData === 'string') {
    return JSON.parse(patientData);
  }

  return patientData;
}

/**
 * Read a nested value from HL7 JSON by segment/object name and inner key.
 *
 * @param {object|string} patientData - Full HL7 JSON payload
 * @param {string} objName - Top-level segment key, e.g. "pid_patient_name"
 * @param {string} key - Nested field key, e.g. "given_name" or "time"
 * @returns {string}
 */
function getPatientData(patientData, objName, key) {
  if (!patientData || !objName || !key) {
    return '';
  }

  try {
    const root = normalizePatientData(patientData);
    const segment = root[objName];

    if (!segment || typeof segment !== 'object') {
      return '';
    }

    const keyValue = findKeyValue(segment, key);
    if (keyValue === null || keyValue === undefined) {
      return '';
    }

    if (key === 'time' && typeof keyValue === 'string') {
      return parseHl7Date(keyValue);
    }

    if (typeof keyValue === 'string') {
      return keyValue;
    }

    if (typeof keyValue === 'number' || typeof keyValue === 'boolean') {
      return String(keyValue);
    }
  } catch (e) {
    console.error('medicalDataParser.getPatientData:', e.message);
  }

  return '';
}

const medicalDataParser = {
  getPatientData,
  findKeyValue,
  parseHl7Date,
};

export default medicalDataParser;
